<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
            name="Update Details"
            bc1="App"
            bc2="POS Devices"
            bc3="Update"
            path="pos-devices"
          ></Breadcrumb>
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Update Details</h4>
                </div>
                <div class="card-body">
                  <form class="form form-horizontal">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label >Name</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text"
                                ><Edit3Icon
                                /></span>
                              </div>
                              <input
                                  type="text"
                                  id="rate-icon"
                                  class="form-control"
                                  v-model="name"
                                  name="name"
                                  placeholder="Name (optional)"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label >Type</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text"
                                ><Edit3Icon
                                /></span>
                              </div>
                              <select class="form-control" v-model="type">
                                <option value="1">POS</option>
                                <option value="2">SoftPOS</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label >Device Model</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text"
                                ><Edit3Icon
                                /></span>
                              </div>
                              <input
                                  type="text"
                                  id="rate-icon"
                                  class="form-control"
                                  v-model="posDeviceModel"
                                  name="name"
                                  placeholder="Device Model"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="name-icon">Device ID</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text"
                                ><Edit3Icon/> </span>
                              </div>
                              <input
                                  type="text"
                                  v-model="deviceId"
                                  class="form-control"
                                  :class="
                                  errorBag.has('deviceId') ? 'is-invalid' : ''
                                "
                                  name="deviceId"
                                  placeholder="Device ID"
                                  v-validate="'required'"
                              />
                              <small
                                  v-show="errorBag.has('deviceId')"
                                  class="invalid-feedback"
                              >{{ "*" + errorBag.first("deviceId") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="rate-icon">IMEI</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text"
                                ><Edit3Icon
                                /></span>
                              </div>
                              <input
                                  type="text"
                                  id="rate-icon"
                                  class="form-control"
                                  v-model="imeiNumber"
                                  name="imeiNumber"
                                  placeholder="IMEI"
                                  :class="
                                  errorBag.has('imeiNumber') ? 'is-invalid' : ''
                                "
                                  v-validate="'required'"
                              />
                              <small
                                  v-show="errorBag.has('imeiNumber')"
                                  class="invalid-feedback"
                              >{{ "*" + errorBag.first("imeiNumber") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="rate-icon">Serial Number</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text"
                                ><Edit3Icon
                                /></span>
                              </div>
                              <input
                                  type="text"
                                  id="code-icon"
                                  class="form-control"
                                  v-model="serialNumber"
                                  name="serialNumber"
                                  placeholder="Serial Number"
                                  :class="
                                  errorBag.has('serialNumber') ? 'is-invalid' : ''
                                "
                                  v-validate="'required'"
                              />
                              <small
                                  v-show="errorBag.has('serialNumber')"
                                  class="invalid-feedback"
                              >{{ "*" + errorBag.first("serialNumber") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label >Status</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text"
                                ><Edit3Icon
                                /></span>
                              </div>
                              <select class="form-control" v-model="status">
                                <option value="1">Active</option>
                                <option value="0">Inactive</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-9 offset-sm-3 d-flex">
                        <button
                          type="button"
                          class="btn btn-primary mr-1 d-flex"
                          @click="sendCall"
                          :disabled="loading"
                        >
                          <Loader :loading="loading" :size="size"></Loader>
                          Save
                        </button>
                        <button
                          type="button"
                          class="btn btn-gradient-secondary"
                          @click="$emit('back')"
                        >
                          Back
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import { TargetIcon, Edit3Icon, CommandIcon } from "vue-feather-icons";

export default {
  components: {
    TargetIcon,
    Edit3Icon,
    CommandIcon
  },
  mounted() {
    let posUpdateData = this.$store.getters.getByKey("posUpdate");
    this.index = posUpdateData.index;
    this.id = posUpdateData.id;
    this.name = posUpdateData.name;
    this.deviceId = posUpdateData.device_id;
    this.imeiNumber = posUpdateData.imei_number;
    this.serialNumber = posUpdateData.serial_number;
    this.posDeviceModel = posUpdateData.device_model
    this.status = posUpdateData.status
    this.type = posUpdateData.type || 1
  },
  data() {
    return {
      id: "",
      index: "",
      loading: false,
      size: "10px",
      deviceId: '',
      posDeviceModel: '',
      imeiNumber: '',
      serialNumber: '',
      name: '',
      type: 1,
      status: 1
    };
  },
  methods: {
    sendCall() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;

          let data = {
            id: this.id,
            name: this.name,
            posDeviceId: this.deviceId,
            imeiNumber: this.imeiNumber,
            serialNumber: this.serialNumber,
            posDeviceModel: this.posDeviceModel,
            status: this.status,
            type: this.type
          }

          this.makeRequest("post", "v1/update-pos-device", data).then(
            callResponse => {
              if (!callResponse.error) {
                let code = callResponse.response.data.code;
                if (code == 200) {
                  this.loading = false;
                  if (callResponse.response.data.data) {
                    let responseData = callResponse.response.data.data;
                    let storeData = this.$store.getters.getByKey("posUpdate");
                    let rawdata = this.$store.getters.getTableData(storeData.storageKey+'_custom')
                    let rowProp = {
                      ...storeData,
                      ...responseData
                    }
                    rawdata[storeData.idx] = rowProp
                    this.$store.dispatch('setTableData', { key: storeData.storageKey+'_custom', data: {...rawdata} })

                    this.$emit('back')
                    return
                  }
                }

              }
              this.loading = false;
            }
          );
        }
      });
    }
  }
};
</script>

